import React, { useContext } from 'react';
import { AppContext } from '../contexts/AppContext';
import { translate } from '../helpers/base';

const DistanceOverlay = () => {
    const { setIsDistanceOverlayVisible, selectedFilters, handleDistanceChange } = useContext(AppContext);
    const distance = parseInt(selectedFilters.distance) || 20;

    const handleClose = () => {
        setIsDistanceOverlayVisible(false);
    };

    const handleChange = (event) => {
        handleDistanceChange(event.target.value);
        setIsDistanceOverlayVisible(false);
    };

    const distances = [1, 5, 10, 20, 30, 40, 50];

    return (
        <div className="accommodation-overview-sort--inner">
            <div className="area--text">
                <p className="lead">{translate('accommodation-overview.results.distance.header')}</p>
                <label className="overlay-close" onClick={handleClose} />
            </div>
            <ul>
                {distances.map((d) => (
                    <li key={d}>
                        <input
                            type="radio"
                            id={`distance-${d}`}
                            value={d}
                            checked={distance === d}
                            onChange={handleChange}
                        />
                        <label htmlFor={`distance-${d}`} className="btn btn-outline btn-sm btn-block">
                            {d} km
                        </label>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default DistanceOverlay;
